import { toast } from "sonner";

const notification = {
  success: (message: string) => {
    toast.success(message, {
      position: "bottom-right",
      style: { color: "#047857" },
    });
  },
  error: (message: string) => {
    toast.error(message, {
      position: "bottom-right",
      style: { color: "#b91c1c" },
    });
  },
  info: (message: string) => {
    toast.info(message, {
      position: "bottom-right",
      style: { color: "#1d4ed8" },
    });
  },
};

export default notification;
